/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DateSelect/view.blocks to change it.
import Content from './Content/index'
import DateTrigger from './DateTrigger/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContent from 'DesignSystem/Popover/PopoverContent/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function DateSelect({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/ScheduleOptions/Content/DateSelect"
  
}) {
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<DateTrigger
{...childProps}
  viewPath={`${viewPath}/DateTrigger`}
/>
)}
</PopoverTrigger>
<PopoverContent
{...childProps}
  viewPath={`${viewPath}/PopoverContent`}
 width={360}
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</PopoverContent>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}